import { Form, Input } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'
import { useSetRecoilState } from 'recoil'

import { kpiFormAtom } from '../../../../recoil/view/atoms'

export const KpiFormNameFormItem = ({
  name,
  setName,
}: {
  name: string | undefined
  setName: (name: string) => void
}): ReactElement => {
  const setForm = useSetRecoilState(kpiFormAtom)

  return (
    <>
      <Form.Item data-e2e="kpi-form-name-form-item-kpi-name" label={t(`KPI名`)} required>
        <Input
          width={200}
          value={name}
          onChange={(event) => {
            setName(event.target.value)
          }}
          // onChangeでsetFormを呼ぶと一文字入力する度に各種Selector等の再計算が走ってしまい
          // 非常に重くなるので更新のタイミングをonBlurにしている
          onBlur={() => {
            setForm((oldValue) => ({ ...oldValue, name }))
          }}
        />
      </Form.Item>
    </>
  )
}
